import { useState, useEffect } from 'react'
import { HiOutlineUsers } from 'react-icons/hi'
import { BiEdit } from 'react-icons/bi'
import { MdSlowMotionVideo } from 'react-icons/md'
import { BsSuitHeart, BsChatSquareText, BsChatText } from 'react-icons/bs'
import { GoHome } from 'react-icons/go'
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaTiktok} from 'react-icons/fa'
import { MdClose } from 'react-icons/md'

import UserAppContext from '../../hook/UserAppContext'
import BannerSection from '../bannersection/BannerSection'
import Social from '../buttons/Social'
import Footer from '../footer/Footer'
import Friends from '../friend/Friends'
import Relation from '../relation/Relation'
import Video from '../video/Video'

import './container.css'

const Container = () => {

      const {user, data} = UserAppContext()
      const [online, setOnline] = useState([])
      const [toggle, setToggle] = useState(false)
      const [current, setCurrent] = useState('')
      const {infordata, banners, social} = user.user
      const id_user = infordata.data || infordata.id_xat === '' ? 0 : infordata.id_xat
      const name = infordata.data || infordata.name === '' ? data.info.name : infordata.name
      const avatar = infordata.data || infordata.avatar === '' ? data.info.avatar : infordata.avatar
      const status = infordata.data || infordata.status === '' ? data.info.status : infordata.status
      const about = infordata.data || infordata.about === '' ? data.info.about : infordata.about 
      const id_xat = infordata.data || infordata.id_xat === '' ? data.info.id_xat : infordata.id_xat
      const banner = banners.data ? data.banner.image : banners[0].image 
      const title = banners.data ? data.banner.title : banners[0].title 
      const initials = infordata.data || infordata.name === '' ? "Me" : infordata.name

      async function getOnline(id){
            try{
                  const response = await fetch(`https://oceanbot.net/online.php?id=${id}`)
                  const result = await response.json()
                  setOnline(result)
            }
            catch(err){
                  console.log('Error: ', err)
            }
      }

      useEffect(() => {
            getOnline(id_user)
      }, [id_user])

      const setMenu = () => {
            if(!toggle){
                  setToggle(true)
            }
            else{
                  setToggle(false)
            }
      }

      const setPage = (page) => {
            setCurrent(page)
            setToggle(false)
      }

      const closePage = () => {
            setCurrent('')
      }

      return (
            <div className="container">
                  <div className="wrapper_content">
                        <BannerSection banner={banner} title={title} isCurrent={current}/>
                        <div className="main_content">
                              <div className="wrapper_menu">
                                    <button className={toggle ? "btn_toggle active" : "btn_toggle"} onClick={() => setMenu()}>
                                          <span className="btn_toggle__bar"></span>
                                          <span className="btn_toggle__bar"></span>
                                          <span className="btn_toggle__bar"></span>
                                    </button>
                                    <div className={toggle ? "toggle_menu active" : "toggle_menu"}>
                                          <ul>
                                                <li className="menu_item">
                                                      <HiOutlineUsers />
                                                      <span onClick={() => setPage('friend')}>Friends</span>
                                                </li>
                                                <li className="menu_item">
                                                      <BsSuitHeart />
                                                      <span onClick={() => setPage('crush')}>Crush</span>
                                                </li>
                                                <li className="menu_item">
                                                      <MdSlowMotionVideo />
                                                      <span onClick={() => setPage('video')}>Video</span>
                                                </li>
                                                <li className="menu_item">
                                                      <BiEdit />
                                                      <a href="https://xat.com/editme" target="_blank" rel="noreferrer">Edit</a>
                                                </li>
                                          </ul>
                                    </div>
                              </div>
                              <div className="wrapper_user">
                                    <h2>{name}</h2>
                                    <p>{status}</p>
                                    <strong>{id_xat}</strong>
                                    <div className="user_menu">
                                          <a href={infordata.homepage === '' ? "https://xat.com" : infordata.homepage} target="_blank" rel="noreferrer"><GoHome /></a>
                                          <a href={infordata.xat_room === '' ? "https://xat.com" : infordata.xat_room} target="_blank" rel="noreferrer"><BsChatText /></a>
                                          <a href={infordata.forum === '' ? "https://forum.xat.com" : infordata.forum} target="_blank" rel="noreferrer"><BsChatSquareText /></a>
                                    </div>
                              </div>
                              <div className="about_user">
                                    <div className="wrapper_online">
                                          <div className={online.status === 'online' ? "online_avatar green" : "online_avatar red"}>
                                                <img src={avatar} alt={name} />
                                          </div>
                                          <span>{online.status === 'online' ? "Online Now" : "Offline"}</span>
                                    </div>
                                    <div className="about_user__description">
                                          <p>{about}</p>
                                    </div>
                              </div>
                        </div>
                        <div className="wrapper_user__avatar">
                              <div className="user_avatar__img">
                                    <img src={avatar} alt={name} />
                              </div>
                              <div className="user_avatar__initials">{initials.substr(0,2)}</div>
                        </div>
                        <div className="main_title">
                              <span>{title}</span>
                        </div>
                        <div className="wrapper_social">
                              <span>Social Networks</span>
                              <div className="social_menu">
                                    <Social link={social.data || social.facebook === '' ? "https://www.facebook.com" : social.facebook} icon={<FaFacebookF />}/>
                                    <Social link={social.data || social.twitter === '' ? "https://www.twitter.com" : social.twitter} icon={<FaTwitter />}/>
                                    <Social link={social.data || social.instagram === '' ? "https://www.instagram.com" : social.instagram} icon={<FaInstagram />}/>
                                    <Social link={social.data || social.youtube === '' ? "https://www.youtube.com" : social.youtube} icon={<FaYoutube />}/>
                                    <Social link={social.data || social.tiktok === '' ? "https://www.tiktok.com" : social.tiktok} icon={<FaTiktok />}/>
                              </div>
                        </div>
                  </div>
                  <div className={current !== '' ? "wrapper_pager show" : "wrapper_pager"}>
                        <button className="btn_close" onClick={() => closePage()}><MdClose /></button>
                        <Friends isCurrent={current} />
                        <Relation isCurrent={current}/>
                        <Video isCurrent={current} />
                  </div>
                  <Footer />
            </div>
      )
}

export default Container
